"use client";

import { getAdminUrl } from "@lib/adminUtils";
import { useAdminMode } from "app/hooks";
import Link from "next/link";
import { MdEdit } from "react-icons/md";

export function AdminEpisodeOptions({
  mode,
  episodeId,
}: {
  mode: "list" | "header";
  episodeId: string;
}) {
  const { data: inAdminMode } = useAdminMode();
  //const [showMenu, setShowMenu] = useState(false);
  return (
    <>
      {inAdminMode && (
        <div className={"admin-ep-opt mode-" + mode}>
          <Link
            href={getAdminUrl(`/episodes/edit?id=${episodeId}&form=edit`)}
            target="_blank"
            className="admin-ep-opt-edit"
          >
            <MdEdit size={16} className="admin-ep-opt-edit-icon" /> 修正
          </Link>
          {/*
          <button
            className={"admin-ep-opt-btn" + (showMenu ? " mode-on" : "")}
            onClick={() => {
              setShowMenu(!showMenu);
            }}
          >
            <MdMoreVert size={18} />
          </button>
          {showMenu && (
            <nav className="admin-ep-opt-menu">
              <Link className="admin-ep-opt-menu-item" href="http://example.com/a" target="_blank">
                他の作品に移動
              </Link>
              <Link className="admin-ep-opt-menu-item" href="http://example.com/b" target="_blank">
                共有用リンク
              </Link>
              <Link className="admin-ep-opt-menu-item" href="http://example.com/c" target="_blank">
                バージョン履歴
              </Link>
            </nav>
          )}
          */}
        </div>
      )}
    </>
  );
}
